// Custom hooks for data fetching using React Query
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';

// Hook to fetch traces
export const useTraces = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['traces', params],
    queryFn: () => apiClient.getTraces(params),
    refetchInterval: options.autoRefresh ? 5000 : false, // Auto-refresh every 5s if enabled
    ...options,
  });
};

// Hook to fetch single trace detail
export const useTraceDetail = (traceId, options = {}) => {
  return useQuery({
    queryKey: ['trace', traceId],
    queryFn: () => apiClient.getTraceDetail(traceId),
    enabled: !!traceId,
    ...options,
  });
};

// Alias for useTraceDetail (used by TraceDetailDrawer)
export const useTrace = useTraceDetail;

// Hook to fetch cost summary
export const useCostSummary = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['costSummary', params],
    queryFn: () => apiClient.getCostSummary(params),
    refetchInterval: options.autoRefresh ? 5000 : false,
    ...options,
  });
};

// Hook to fetch modality summary
export const useModalitySummary = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['modalitySummary', params],
    queryFn: () => apiClient.getModalitySummary(params),
    refetchInterval: options.autoRefresh ? 5000 : false,
    ...options,
  });
};

// Hook to fetch alerts
export const useAlerts = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['alerts', params],
    queryFn: () => apiClient.getAlerts(params),
    refetchInterval: options.autoRefresh ? 10000 : false, // Refresh every 10s
    ...options,
  });
};

// Hook for health check
export const useHealth = () => {
  return useQuery({
    queryKey: ['health'],
    queryFn: () => apiClient.getHealth(),
    refetchInterval: 30000, // Check every 30s
  });
};
